'use strict';

exports.__esModule = true;
var cn = function cn() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(Boolean).join(' ');
};

exports.default = cn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-live/lib/utils/cn.js
// module id = 62
// module chunks = 35783957827783